<template>
  <div class="big-screen">
    <div class="top_block">
      <div style="flex: 1">
        <el-radio-group v-model="technicianState" @input="userListNameInput">
          <el-radio-button :label="item.typeName" v-for="item of userListName" :key="item.id"></el-radio-button>
        </el-radio-group>
      </div>
      <div class="switch">
        <el-switch
          @change="showHide($event, 'arrangingReport')"
          v-model="btnSearch.arrangingReport"
          inactive-text="播报待安排"
        ></el-switch>
        <el-switch @change="showHide($event, 'circle')" v-model="btnSearch.signable" inactive-text="未签到"></el-switch>
        <el-switch @change="showHide($event, 'stop')" v-model="btnSearch.stop" inactive-text="停牌修假"></el-switch>
        <el-switch
          @change="showHide($event, 'dropOut')"
          v-model="btnSearch.dropOut"
          inactive-text="落牌技师"
        ></el-switch>
      </div>
      <el-input-number v-model="num" @change="handleChange" :min="1" :max="100" label="描述文字"></el-input-number>
      <div class="set-up" @click="dialogVisible = true">
        <i class="el-icon-setting"></i>
        <span style="color: #606266">设置</span>
      </div>
      <div class="user">
        <i class="el-icon-user"></i>
        <span style="color: #606266">{{ $store.state.user.userInfo.phonenumber }}</span>
      </div>
      <el-button class="login-btn" @click="login">退出登录</el-button>
    </div>
    <div class="buttom">
      <div
        class="classify"
        :style="{
          zoom: num / 50
        }"
      >
        <div class="classify_box" v-for="(item1, index1) in clockList" :key="index1">
          <div class="left">
            <span class="left_a">
              {{ item1.artificerName }}
              <span class="left_b"></span>
            </span>
          </div>
          <div class="right">
            <div
              class="classify_box_item"
              :style="{
                backgroundColor: jishiBgc(item2),
              }"
              v-for="(item2, index2) in item1.useChimesArtificerInfoList"
              :key="index2"
            >
              <div class="top">
                <span class="left-text">
                  <i class="el-icon-s-custom" v-if="item2.sex === 1" style="color: #e33e32;font-size: 18px;"></i>
                  <i class="el-icon-s-custom" v-else style="color: #2b57e7;font-size: 18px;"></i>
                  {{ item2.artificerNumber }}
                </span>
                <span class="right-text">
                  {{ item2.movingCardNum ? `${item2.movingCardNum}动` : "" }}
                </span>
              </div>
              <div
                class="bottom"
                :style="{ color: textColor(jishiBgc(item2)) }"
              >
                <div class="bottom_top">
                  <div class="a" v-if="btnSearch.level">
                    {{ item2.artificerLeaveName }}
                  </div>
                  <div class="b">{{ item2.classesName }}</div>
                  <div class="status-text">
                    <div class="c" v-if="item2.goClassesType != 0">
                      {{ item2.goClassesTypeName }}
                    </div>
                    <div class="c" v-if="item2.status == 4 || item2.stayLockPlateNum">约</div>
                    <div
                      class="c"
                      v-if="
                        item2.serviceRoomNum !== null ||
                        (item2.serviceRoomNum === null && item2.itemName) ||
                        (item2.status === 5 && item2.itemName)
                      ">
                      {{ item2.statusName }}
                    </div>
                  </div>
                </div>
                <div
                  class="bottom_center"
                  v-if="
                    item2.serviceRoomNum === 0 ||
                    (item2.serviceRoomNum === null && !item2.itemName) ||
                    (item2.status === 5 && !item2.itemName)
                  ">
                  <span>{{ item2.statusName }}</span>
                </div>
                <div class="bottom_bottom">
                  <div class="bottom_bottom_left">
                    {{ item2.serviceRoomNum ? `${item2.serviceRoomNum}房` : "" }}
                  </div>
                  <div class="bottom_bottom_a" v-if="item2.status !== 0">
                    {{ item2.itemName }} {{ goClockTypes[item2.goClockType] }}
                    <span v-if="item2.addClockNum">{{ `+${item2.addClockNum}` }}</span>
                  </div>
                  <div class="bottom_bottom_a">
                    <span v-if="item2.startLockTime && item2.status !== 0 && !item2.residueTimeLength">
                      {{ `锁定 ${newTime(item2.startLockTime)}分钟` }}
                    </span>
                    <span>
                      {{
                        item2.residueTimeLength
                          ? `${item2.residueTimeLength < 0 ? "超时" : "余"} ${item2.residueTimeLength}分钟`
                          : ""
                      }}
                    </span>
                  </div>
                  <div class="bottom_bottom_time" v-if="item2.exceptionStatusStartTime">
                    <div>{{ item2.statusName }}</div>
                    <div v-if="item2.exceptionStatusStartTime">{{ item2.exceptionStatusStartTime.slice(5, 16) }}</div>
                    <div v-if="item2.exceptionStatusEndTime">~ {{ item2.exceptionStatusEndTime.slice(10, 16) }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="voiceBroadcast">
        <div class="title">语音播报列表</div>
        <div>
          <div class="langText" v-for="(item, index) in items" :key="index">
            <span>{{ item.text }}</span>
            <!-- <el-button type="text" @click="speak(item.text)">播放</el-button> -->
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="播放设置"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      width="500px"
    >
      <div class="set-config-row">
        <span style="margin-right: 20px;">播放次数</span>
        <el-input-number v-model="clockRoomConfig.playCount" :min="1" :max="10" label="请输入同一段话播放次数"></el-input-number>
      </div>
      <div class="set-config-row">
        <span style="margin-right: 20px;">播放速度</span>
        <el-slider :show-tooltip="false" v-model="clockRoomConfig.playSpeed" style="width: 200px;" :max="3" :min="0.1" :step="0.1"></el-slider>
        <span style="margin-left: 20px;">{{ clockRoomConfig.playSpeed }}倍</span>
        
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitSetConfig">确 认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { 
  selectArtificerReqSettings,
  submitArtificerReqSettings,
  allList, userListTypeName,
  selUserStatusColor,
  getBusinessTime,
  getConfig,
  updateConfig
} from "@/api/home.js"
import { parseTime } from '@/utils/ruoyi'

import { text2Audio } from "@/api/small"

let localStorageKey = 'CLOCK_TEXT_ITEM_KEY'
let audioFiles = []
let audioPool = false

export default {
  // inject: ["reload"],
  data() {
    return {
      goClockTypes: {
        0: "轮钟",
        1: "选牌",
        2: "点钟",
        3: "Call钟",
        4: "旷钟",
      },
      items: [],
      num: 50,
      clockList: [],
      btnSearch: {},
      technician: {},
      speech: null,
      websocket: null,
      loadPages: null,
      technicianState: "主牌",
      userListName: [],
      technicianListObj: {
        moreBellId: "",
        moreBellName: ""
      },

      clockRoomConfig: {
        playSpeed: 1,
        playCount: 1
      },
      dialogVisible: false,
    }
  },
  computed: {
    newTime() {
      return (val) => {
        return Math.floor((Date.now() - Date.parse(val)) / 60000)
      }
    },
    textColor() {
      return (val) => {
        return this.isLight(val) ? "#000000" : "#ffffff";
      };
    },
    jishiBgc() {
      return (val) => {
        return val.status !== 2 ? this.technician[+val.status] : this.technician[+("2" + val.goClockType)];
      }
    },
  },
  created() {
    userListTypeName().then((res) => {
      this.userListName = res.data
    })
    const objs = JSON.parse(window.localStorage.getItem(localStorageKey)) || []
    if (objs && objs.length > 0) {
      // this.items.unshift(objs);
      this.items = objs
    }
    this.loadPage()
    this.getClockRoomConfig()
  },
  async mounted() {
    await this.getTechnicianColors();
    this.createdList()
    this.selectStatus()
    this.selectBusinessTime()
  },
  beforeDestroy() {
    console.log("关闭定时器")
    window.clearInterval(this.loadPages)
  },
  methods: {
    userListNameInput(val) {
      let id = this.userListName.filter((item) => item.typeName === val)[0].id
      console.log(val)
      this.technicianListObj = {
        moreBellId: val ? id : "",
        moreBellName: val ? val : ""
      }
      this.$nextTick(() => {
        this.gettechnicianList(this.technicianListObj)
      })
    },
    loadPage() {
      window.clearInterval(this.loadPages)
      this.loadPages = window.setInterval(() => {
        this.selectStatus()
        this.selectBusinessTime()
      }, 60000)
    },
    createdList() {
      this.$socketBus.$on("ws-message", this.messageSocket);
    },
    async messageSocket(res) {
      if ([31, 32, 33, 34, 25].includes(res.type)) {
        if (this.items.length > 15) {
          this.items.splice(this.items.length - 1, 1)
        }
        this.items.unshift({ 
          text: res.data.message + ' ' + parseTime(new Date().getTime(), "{d}/{h}:{i}"),
          time: new Date().getTime()
        })
        window.localStorage.setItem(localStorageKey, JSON.stringify(this.items))
        this.textToAudio(res.data)
      }
      if (res.type == 28) {
        await this.getTechnicianColors()
        this.selectStatus()
      }
    },
    async textToAudio(val) {
      let texts = ''
      try {
        texts = val.voiceTexts.join('');
        console.log(texts);
        
      } catch (error) {
        texts = val.message
      }
      let { data } = await text2Audio({ texts: val.voiceTexts })
      let list = []
      let num = this.clockRoomConfig.playCount || 1
      for (let i = 0; i < num; i++) {
        list = [...list, ...data]
      }
      this.awaitPlay(list)
    },
    awaitPlay(data) {
      audioFiles = [...audioFiles, ...data]
      if (audioPool) {
        return
      } else {
        audioPool = true
        this.playNext(audioFiles[0])
      }
    },
    playNext(file) {
      try {
        let _this = this
        let audioContext = new Audio(process.env.VUE_APP_BASE_fileURL + file)
        audioContext.playbackRate = this.clockRoomConfig.playSpeed || 1
        audioContext.play().then(() => { })
        .catch(error => {
          console.log(error);
          audioFiles.splice(0, 1)
          if (audioFiles.length > 0) {
            _this.playNext(audioFiles[0])
          } else {
            audioPool = false
            audioFiles = []
            console.log('播放完成');
          }
        })
        audioContext.addEventListener('canplay', () => { })
        audioContext.addEventListener('ended', () => {
          audioFiles.splice(0, 1)
          if (audioFiles.length > 0) {
            _this.playNext(audioFiles[0])
          } else {
            audioPool = false
            audioFiles = []
            console.log('播放完成');
          }
        })
      } catch (error) {
        console.log(error);
      }
    },
    showHide(val, key) {
      this.btnSearch[key] = val
      window.localStorage.setItem('artificerSettings', JSON.stringify(this.btnSearch))
      this.selectStatus()
      // const arr = Object.entries(this.btnSearch).map((item) => {
      //   item[1] = Number(item[1])
      //   return [item[0], item[1]]
      // })
      // const obj = {}
      // arr.forEach((item) => {
      //   obj[item[0]] = item[1]
      // })
      // submitArtificerReqSettings(obj).then((res) => {
      //   if (res.code == 200) {
      //     this.selectStatus()
      //   }
      // })
    },
    selectStatus() {
      // 钟房设置单独配置 不跟设置走
      let artificerSettings = JSON.parse(window.localStorage.getItem('artificerSettings'))
      if (artificerSettings) {
        this.btnSearch = artificerSettings
      } else {
        this.btnSearch = {
          addArrangeNums: true,
          arrangingReport: true,
          circle: true,
          dropOut: true,
          level: true,
          moveArrangeNums: true,
          offWork: true,
          stop: true,
        }
        window.localStorage.setItem('artificerSettings', JSON.stringify(this.btnSearch))
      }
      this.gettechnicianList(this.technicianListObj)
    },
    gettechnicianList(val) {
      allList(val)
        .then((res) => {
          this.techniciansOldT = res.data.artificerTypeVoList
          this.techniciansOld = JSON.parse(JSON.stringify(this.techniciansOldT))
          this.statusInfoVoList = res.data.statusInfoVoList
        })
        .then(() => {
          this.clockList = this.techniciansOld.map((item) => {
            let arr = item.useChimesArtificerInfoList.filter((value) => {
              if (value.status == 11) {
                return !!this.btnSearch.dropOut
              } else if (value.status == 6 || value.status == 14) {
                return !!this.btnSearch.stop
              } else if (value.status == 5) {
                return !!this.btnSearch.circle
              } else {
                return true
              }
            })
            return {
              ...item,
              useChimesArtificerInfoList: arr
            }
          })
        })
    },
    handleChange(value) {
      console.log(value)
    },
    login() {
      this.$store.dispatch("LogOut").then(() => {
        location.href = "/index"
      })
    },
    isLight(color) {
      const rgb = parseInt(color.substring(1), 16);
      const r = (rgb >> 16) & 0xff;
      const g = (rgb >> 8) & 0xff;
      const b = (rgb >> 0) & 0xff;
      const luma = 0.2126 * r + 0.7152 * g + 0.0722 * b;
      return luma > 165;
    },
    async getTechnicianColors() {
      let { data } = await selUserStatusColor()
      data = data.map((item) => {
        if (item.colors === null) {
          return { ...item, colors: item.defaultColors };
        } else {
          return item;
        }
      });
      for (let key of data) {
        if (key.type === "1") {
          this.technician[2 + key.userStatus] = key.colors;
        } else {
          this.technician[key.userStatus] = key.colors;
        }
      }
    },
    async selectBusinessTime() {
      getBusinessTime().then(({ data }) => {
        let startTime = new Date(data.startTime).getTime()
        let endTime = new Date(data.endTime).getTime()
        if (this.items.length > 0) {
          this.items = this.items.filter(e => startTime < e.time && e.time < endTime)
          window.localStorage.setItem(localStorageKey, JSON.stringify(this.items))
        }
      })
    },
    async getClockRoomConfig() {
      let { data } = await getConfig({ key: 'clock_room_config' })
      try {
        this.clockRoomConfig = JSON.parse(data) || {
          playSpeed: 1,
          playCount: 1
        }
      } catch (error) {
        this.clockRoomConfig = {
          playSpeed: 1,
          playCount: 1
        }
      }
    },
    async submitSetConfig() {
      await updateConfig({
        key: 'clock_room_config',
        value: JSON.stringify(this.clockRoomConfig)
      })
      this.$message.success('同步数据成功')
      this.handleClose()
    },
    async handleClose() {
      this.dialogVisible = false
      this.getClockRoomConfig()
    }
  },
  destroyed() {
    // this.speech.cancel()
    // this.$bus.$on("refresh", () => {
    //   this.reload();
    // });
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/css/element-variables.scss";

.set-config-row {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}

.buttom {
  display: flex;
}
.voiceBroadcast {
  width: 20%;
  height: 725px;
  background-color: #000;
  color: #fff;
  margin-left: 2%;
  overflow: hidden;
  .title {
    font-size: 18px;
    height: 35px;
    background-color: #55668a;
    color: #fff;
    line-height: 35px;
    padding-left: 15px;
  }
  .langText {
    // height: 35px;
    padding: 10px;
  }
}
.big-screen {
  margin: 0px 30px;
  .top_block {
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: right;
    .switch {
      .el-switch {
        margin: 0 10px;
      }
    }
    .el-input-number {
      margin: 0 18px;
    }
    .set-up {
      // margin-right: 20px;
      padding: 10px 20px 10px 0;
      cursor: pointer;
    }
  }
  .user {
    margin-right: 20px;
  }
  .classify {
    width: 77%;
    .classify_box {
      display: flex;
      width: 100%;
      margin-bottom: 1px;
      // border: 1px solid #ccc;
      .left {
        width: 40px;
        background-color: #3c4869;
        display: flex;
        color: #fff;
        align-items: center;
        justify-content: center;
        .left_a {
          writing-mode: tb-rl;
          .left_b {
            writing-mode: lr-tb;
          }
        }
      }
      .right {
        width: 100%;
        display: flex;
        justify-content: left;
        flex-wrap: wrap;
        padding: 10px;
        .classify_box_item {
          background-color: $--color-primary;
          // border: 1px solid #d7dae0;
          // border-radius: 10px;
          overflow: hidden;
          width: 150px;
          height: 150px;
          margin: 0 5px 5px 0;
          cursor: pointer;
          position: relative;
          .two {
            justify-content: space-between;
          }
          .top {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-left: 10px;
            padding-right: 10px;
            background-color: rgba(255, 255, 255, 0.8);
            min-height: 25%;
            min-width: 100%;
            .left-text {
              font-weight: 600;
              font-size: 26px;
            }
            .right-text {
              font-size: 13px;
            }
            // .price {
            //   color: #e33e32;
            //   font-size: 12px;
            //   font-weight: 400;
            // }
          }
          .bottom {
            min-height: 75%;
            min-width: 100%;
            display: flex;
            flex-direction: column;
            color: #000;
            padding: 5px;
            .bottom_top {
              display: flex;
              align-items: center;
              white-space: nowrap;
              flex-wrap: wrap;
              .a {
                font-size: 14px;
                margin-right: 5px;
              }
              .b {
                font-size: 14px;
              }
              .status-text {
                // flex: 1;
                display: flex;
                align-items: center;
                justify-content: end;
                margin-left: 2px;
              }
              .c {
                font-size: 14px;
                background-color: rgba(0, 0, 0, 0.3);
              }
            }
            .bottom_center {
              display: flex;
              align-items: center;
              justify-content: center;
              margin-top: 5px;
              span {
                padding: 2px 10px;
                font-size: 14px;
                font-weight: 700;
                background-color: rgba($color: #000000, $alpha: 0.1);
                border-radius: 20px;
              }
            }
            .bottom_bottom {
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              // margin-top: 10px;
              .bottom_bottom_a {
                font-size: 14px;
              }
              .bottom_bottom_left {
                font-size: 14px;
              }
              .bottom_bottom_right {
                position: absolute;
                bottom: 5px;
                right: 5px;
                .circle {
                  width: 32px;
                  height: 32px;
                  border: 2px solid #fff;
                  border-radius: 50%;
                  background-color: rgba($color: #000000, $alpha: 0.2);
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  color: #fff;
                  font-weight: 600;
                  font-size: 22px;
                }
                transition: all 0.3s;
              }
              .bottom_bottom_time {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                font-size: 14px;
                margin-top: 10px;
              }
            }
          }
          .colorFFF {
            color: #fff;
          }
          .rightMenu {
            position: absolute;
            bottom: -290px;
            z-index: 9;
            width: 180px;
            left: 0px;
            padding: 10px;
            display: flex;
            flex-wrap: wrap;
            border-radius: 10px;
            background-color: rgba($color: #000000, $alpha: 0.8);
            .item {
              width: 50%;
              text-align: left;
              padding: 8px;
              font-size: 14px;
              &:hover {
                background-color: #fff;
                color: #000;
              }
            }
          }
          .triangle {
            width: 0;
            height: 0;
            border: 10px solid transparent;
            border-bottom: 10px solid rgba($color: #000000, $alpha: 0.8);
            position: absolute;
            bottom: 10px;
            left: 80px;
            z-index: 9;
          }
        }
        .aa {
          background-color: #afb9cc;
        }
        .bb {
          background-color: #589ccd;
        }
      }
    }
  }
}
</style>
